import { useSheetDrag } from '../../../hooks/useSheetDrag.js';
import { ASSISTED_COPY } from './assistedCopy.js';
import './assisted.css';

interface AssistedIntroSheetProps {
  sceneTitle: string;
  onStart: () => void;
  onSolo: () => void;
}

/**
 * La hoja corta al empezar una escena en «Asistida» (encargo 99): cómo funciona
 * y que no suma vocabulario ni cambia el nivel. Reusa la hoja inferior de la
 * charla (`drill-overlay` / `leave-sheet`, la de «¿Salir tan pronto?») con la
 * forma de la maqueta 1 (`asst-intro`: los pasos numerados en lima, la nota
 * punteada y «Mejor solo» con borde). «Mejor solo» arranca la escena como
 * siempre, sin ayuda.
 */
export function AssistedIntroSheet({ sceneTitle, onStart, onSolo }: AssistedIntroSheetProps) {
  const copy = ASSISTED_COPY.es.intro;
  const { grabProps, sheetStyle } = useSheetDrag(onStart);
  return (
    <div className="drill-overlay" onClick={onStart}>
      <div
        className="leave-sheet asst-intro"
        style={sheetStyle}
        role="dialog"
        aria-label={copy.title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="drill-handle sheet-grab" {...grabProps} />
        <div className="leave-sheet-body">
          <div className="leave-sheet-title">{copy.title}</div>
          <div className="leave-sheet-sub">{copy.sub(sceneTitle)}</div>
          <ol className="asst-steps">
            {copy.steps.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ol>
          <div className="asst-intro-note">{copy.note}</div>
          <button type="button" className="leave-sheet-stay" onClick={onStart}>
            {copy.start}
          </button>
          <button type="button" className="leave-sheet-go" onClick={onSolo}>
            {copy.solo}
          </button>
        </div>
      </div>
    </div>
  );
}
